<template>
  <tr
    :class="{'opacity-50 bg-light': !variant.is_active || baseIsInStock == 0}"
  >
    <td>
      <div class="d-flex align-items-center">
        <input
          class="form-check-input me-2 mt-0 shadow-none"
          type="checkbox"
          v-model="variant.is_active"
          :title="$t('Enable/Disable this variant')"
          :disabled="baseIsInStock == 0"
        >
        <span class="text-truncate" style="min-width: 100px; font-size: 0.85rem;">
          {{ variant.name }}
        </span>
      </div>
    </td>

    <td class="text-end px-2">
      <div v-if="!variant.is_custom_price || !variant.is_active || baseIsInStock == 0" class="d-flex align-items-center justify-content-end">
        <span class="text-muted small me-2">{{ variant.price }}</span>
        <button
          type="button"
          class="btn btn-sm btn-light border py-1 px-2 text-theme"
          @click="variant.is_custom_price = true;"
          :disabled="!variant.is_active || baseIsInStock == 0"
        >
          <i class="fa-solid fa-pen-to-square" />
        </button>
      </div>

      <div v-else class="d-flex align-items-center justify-content-end">
        <input
          type="number"
          class="form-control form-control-sm fw-bold me-1 shadow-none text-end text-theme w-auto"
          v-model="variant.price_override"
          :disabled="!variant.is_active || baseIsInStock == 0"
          :placeholder="variant.price"
        >
        <button
          type="button"
          data-bs-toggle="popover"
          data-bs-placement="top"
          class="btn btn-sm btn-light border text-danger py-1 px-2"
          @click="variant.is_custom_price = false; variant.price_override = ''"
          :disabled="!variant.is_active || baseIsInStock == 0"
        >
          <i class="fa-solid fa-rotate-left" />
        </button>
      </div>
    </td>

    <td class="text-center">
      <select
        class="form-select form-select-sm shadow-none"
        v-model="variant.is_in_stock"
        :disabled="!variant.is_active || baseIsInStock == 0"
      >
        <option :value="true">{{ $t('In Stock') }}</option>
        <option :value="false">{{ $t('Out of Stock') }}</option>
      </select>
    </td>
  </tr>
</template>

<script>
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-branch-variant-item";
import Ladda from '@/plugins/Ladda.vue';
import Popper from "vue3-popper";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.variant);
  },
  props: {
    variant: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      required: true
    },
    baseIsInStock: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    Popper
  },
  data() {
  }
}
</script>
